import type { OrganizationLimit } from '../../../shared/organizations/types';
import { window } from '../../globals';
import * as api from '../../redux/api';
import { useAsyncRequest } from '../index';

/**
 * Fetches the current contributor limits and usage for the organization.
 */
export async function getContributorLimit(): Promise<Response & { data?: OrganizationLimit }> {
  const orgId = window?.user?.organizationId ?? 0;
  return api.get<OrganizationLimit>(`/api/organizations/${orgId}/limits/contributors`);
}

/**
 * Hook to fetch and calculate the contributor limit status.
 */
export const useContributorLimit = () => {
  const contributorLimitAsyncValue = useAsyncRequest(getContributorLimit);
  const responseData = contributorLimitAsyncValue?.value;
  const isContributorsUnlimited = responseData?.unlimited === true;
  const isAtContributorLimit = !isContributorsUnlimited && responseData?.usage === responseData?.max;
  const isOverContributorLimit =
    !isContributorsUnlimited && !!responseData?.usage && responseData?.usage > responseData?.max;

  return { ...contributorLimitAsyncValue, isAtContributorLimit, isOverContributorLimit, isContributorsUnlimited };
};
